define('common/module/realtime/Serum.RealtimeEventEmitter',[
  'common/js/lib/Serum.Pubsub'
], function(Pubsub) {

  'use strict';

  function EventEmitter() {

    function onUpdate(id, version, data) {
      Pubsub.publish('REALTIME_CONTENT_UPDATE', {
        id : id,
        version : version,
        update : data
      });
    }

    return {
      subscribeTo : function(id, version) {}, // eslint-disable-line no-unused-vars
      unsubscribeFrom : function(id) {}, // eslint-disable-line no-unused-vars

      onUpdate : onUpdate
    };
  }

  return EventEmitter;
});
